import { Modifier } from "@/dto/modifer";
import { ItemNameWithQuantity } from "./itemNameWithQuantity";
import { AgeRestricted } from "@/components/ageRestricted/ageRestricted";
import { CartItemModifierList } from "./cartItemModifierList";

export interface ScanToOrderCartItemLeftProps {
  name: string;
  quantity: number;
  isAgeRestricted?: boolean;
  modifiers: Modifier[];
  specialInstructions?: string;
}

export const ScanToOrderCartItemLeft = ({
  name,
  quantity,
  isAgeRestricted,
  modifiers,
  specialInstructions,
}: ScanToOrderCartItemLeftProps) => (
  <>
    <div className="w-full flex flex-col justify-between">
      <ItemNameWithQuantity name={name} quantity={quantity} />
      {isAgeRestricted && (
        <AgeRestricted text="Government-issued ID required" />
      )}
      <CartItemModifierList
        modifiers={modifiers}
        specialInstructions={specialInstructions}
      />
    </div>
  </>
);
